import React, { useEffect, useState } from 'react';
import * as Request from '../../common/request';
import Page from '../../components/page';
import { Tabs } from 'antd-mobile'
import Success from '../adminupkeepinfo';
import './index.less';

const PageModel = props => {
	useEffect(() => {
		
	}, [123]);

	return (
		<Page {...{ page: 'alltab', showFooter: false, title: '设备保养情况' }} {...props}>
			<Tabs>
				<Tabs.Tab title='已保养' key='0'>
					<Success  props={props} type="1"/>
				</Tabs.Tab>
				<Tabs.Tab title='未保养' key='1'>
					<Success props={props} type="2"/>
				</Tabs.Tab>
			</Tabs>
		</Page>
	);
};

export default PageModel;
